<mat-toolbar class="toolbar">
  <h1 class="page-title">
    <mat-icon fontIcon="add"></mat-icon>
    {{'units.add_unit'| translate}}
  </h1>

  <lib-button (click)="closeDialog('cancel')" icon="close" color="none" textColor="muted">
  </lib-button>
</mat-toolbar>

<form (ngSubmit)="saveUnit($event)" class="form">
  <h3>
    <mat-icon fontIcon="info"></mat-icon>
    {{'resources.info_unit' | translate}}
  </h3>

  <div class="row">
    <mat-form-field appearance="outline" class="header-input">
      <mat-label>{{'form.name' | translate}}</mat-label>

      <input matInput placeholder="{{'form.name' | translate}}" [(ngModel)]="currentUnit.name" name="name">

      <mat-hint class="error-unique" *ngIf="errorName">{{'units.error_unique' | translate}} </mat-hint>
    </mat-form-field>
  </div>

  <div class="row mobile">
    <!-- Tracker select field -->
    <mat-form-field appearance="outline">
      <mat-label>{{'units.tracker' | translate}}</mat-label>
      <mat-select [(ngModel)]="currentUnit.trackers" name="trackers" multiple>
        <mat-option *ngFor="let tracker of availableTrackers" [value]="tracker.id">
          {{ tracker.name }}
        </mat-option>
        <mat-option *ngFor="let tracker of usedTrackers" [value]="tracker.id" disabled>
          {{ tracker.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="currentUnit?.trackerError">{{'form.error' | translate}}</mat-error>
    </mat-form-field>

    <!-- Type select field -->
    <mat-form-field appearance="outline">
      <mat-label>{{'units.type' | translate}}</mat-label>
      <mat-select [(ngModel)]="currentUnit.type" name="type">
        <mat-option *ngFor="let unit of unitTypeArray" [value]="unit.value">
          {{ unit.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- <mat-divider></mat-divider> -->

  <h3>
    <mat-icon fontIcon="location_on"></mat-icon>
    {{'units.coordinates' | translate}}
  </h3>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>X</mat-label>
      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.x" name="x">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Y</mat-label>
      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.y" name="y">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Z</mat-label>
      <input matInput type="number" placeholder="0" [(ngModel)]="currentUnit.lastPosition.z" name="z">
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>{{'geometry.longitude' | translate}}</mat-label>
      <input matInput type="number" placeholder="0" name="lon" [(ngModel)]="currentUnit.lastPosition.lon">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{'geometry.latitude' | translate}}</mat-label>
      <input matInput type="number" placeholder="0" name="lat" [(ngModel)]="currentUnit.lastPosition.lat">
    </mat-form-field>
  </div>
  <!-- <mat-divider></mat-divider> -->

  <mat-dialog-actions class="actions">
    <span class="resource-spacer"></span>

    <lib-button type="button" (click)="closeDialog('cancel')" [text]="'viewer.close' | translate" color="outline"
      icon="close">
    </lib-button>

    <lib-button type="submit" [text]="'viewer.save' | translate" color="primary" icon="save">
    </lib-button>
  </mat-dialog-actions>
</form>